"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('snowflake', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(6.000000, 4.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M18,0 L18,40"
  }), _react.default.createElement("path", {
    d: "M0.73697589,9.97927459 L35.3540273,30.0207254",
    transform: "translate(18.045502, 20.000000) rotate(-0.068583) translate(-18.045502, -20.000000) "
  }), _react.default.createElement("path", {
    d: "M0.730852571,29.9979275 L35.2691474,10.0020725",
    transform: "translate(18.000000, 20.000000) rotate(0.068583) translate(-18.000000, -20.000000) "
  }), _react.default.createElement("polyline", {
    points: "6 6 9 15 0 17"
  }), _react.default.createElement("polyline", {
    points: "0 23 9 25 6 34"
  }), _react.default.createElement("polyline", {
    points: "30 6 27 15 36 17"
  }), _react.default.createElement("polyline", {
    points: "36 23 27 25 30 34"
  }), _react.default.createElement("polyline", {
    points: "12 3 18 9 24 3"
  }), _react.default.createElement("polyline", {
    points: "12 37 18 31 24 37"
  }))));
});

exports.default = _default;